import React from 'react';

/**
 * Skeleton — shimmer placeholder for loading states.
 * The `.skeleton` CSS class + keyframe lives in animations.css.
 */
export default function Skeleton({ width = '100%', height = 20, rounded = false, className = '', style = {} }) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius: rounded ? 'var(--radius-full)' : undefined,
        flexShrink: 0,
        ...style,
      }}
      aria-hidden="true"
    />
  );
}
